const cartCookie = 'lm_cart';

export default cartCookie;
